<template>
  <!-- 大咖锦囊列表 -->
  <div class="list">
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="goto(`/excl-author/jinnang/${item.jinNangId}/repo`, item)"
      class="item"
    >
      <div class="item-head item-list">
        <div class="head-key">{{ item.title }}</div>
        <div
          :class="{
            'head-status': true,
            active: item.statusStr === '销售中',
            unactive: item.statusStr !== '销售中'
          }"
        >
          {{ item.statusStr }}
        </div>
      </div>
      <div class="item-split"></div>
      <div class="item-body">
        <div class="item-list">
          <div class="item-list-key">创建日期</div>
          <div class="item-list-value">{{ formatTime(item.createTime) }}</div>
        </div>
        <div class="item-list">
          <div class="item-list-key">当前服务人数</div>
          <div class="item-list-value">{{ item.serviceNum }}</div>
        </div>
        <div class="item-list">
          <div class="item-list-key">剩余名额</div>
          <div class="item-list-value">{{ item.leftServiceNum }}</div>
        </div>
        <div class="item-list">
          <div class="item-list-key">单价</div>
          <div class="item-list-value c9">¥{{ item.price }}/月</div>
        </div>
        <div class="item-list">
          <div class="item-list-key">仓位</div>
          <div class="item-list-value">{{ item.mktLevel }}</div>
        </div>
        <div class="item-list">
          <div class="item-list-key">总收益</div>
          <div
            class="item-list-value"
            :class="[
              getSymbol(item.glYield) > 0
                ? 'c1'
                : getSymbol(item.glYield) < 0
                ? 'c3'
                : ''
            ]"
          >
            {{ item.glYield ? item.glYield : '--' }}
          </div>
        </div>
      </div>
    </div>
    <div class="item tagWrapper" @click="goto('/excl-author/jinnang/apply')">
      <div class="tag"></div>
      <div class="tag-title">申请锦囊</div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'AuthorJinNangList',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  watch: {},
  methods: {
    goto(router, item) {
      if (item && item.statusStr === '待审核') {
        this.$message.info('锦囊未生效')
      } else {
        this.$router.push(router)
      }
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.item {
  background-color: #ffffff;
  border-radius: 5px;
  flex: none;
  height: 300px;
  padding: 0 30px;
  margin-bottom: 20px;
  cursor: pointer;
}

.item:hover {
  box-shadow: 0px 0px 20px 0px rgba(4, 107, 204, 0.3);
}

.item-head {
  height: 59px;
}

.head-key {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 1px;
  color: #262626;
}

.head-status {
  width: 60px;
  height: 22px;
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 1px;
  text-align: center;
}

.active {
  color: #046bcc;
  background-color: rgba(4, 107, 204, 0.1);
}

.unactive {
  background-color: rgba(133, 133, 133, 0.1);
  color: #858585;
}

.item-body {
  height: 182px;
  margin: 29px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item-split {
  height: 1px;
  background-color: #ebebeb;
}

.item-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-split {
  width: 363px;
  height: 1px;
  background-color: #ebebeb;
}

.item-list-key {
  height: 14px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #858585;
}

.item-list-value {
  height: 12px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
}

.c9 {
  color: #046bcc;
}

.tagWrapper {
  width: 363px;
}

.tag {
  width: 60px;
  height: 60px;
  background-color: rgba(4, 107, 204, 0.1);
  margin-top: 106px;
  margin-left: 152px;
  position: relative;
  border-radius: 50%;
}

.tag::before {
  content: '';
  position: absolute;
  left: 29px;
  top: 17px;
  width: 2px;
  height: 26px;
  background-color: #046bcc;
}
.tag::after {
  content: '';
  position: absolute;
  left: 17px;
  top: 29px;
  width: 26px;
  height: 2px;
  background-color: #046bcc;
}

.tag-title {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 16px;
  color: #046bcc;
  text-align: center;
  margin-top: 12px;
}
</style>
